// Generated from the live store copy. Prices in EGP, availability as of 2026-10-25.
window.ALTIERO = {
 "freeShippingThreshold": 1999,
 "currency": "EGP",
 "products": [
  {
   "handle": "altieros-matte-black-leather-jacket",
   "shopTitle": "Leather Jacket - Noir",
   "name": "Leather Jacket",
   "colour": "Noir",
   "swatch": "#1d1c1b",
   "family": "leather-jacket",
   "category": "jackets",
   "collection": "fw26",
   "price": 1380.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 49917389242627
    },
    {
     "size": "M",
     "available": true,
     "variantId": 49917389275395
    },
    {
     "size": "L",
     "available": true,
     "variantId": 49917389308163
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 49917389340931
    }
   ],
   "details": [
    "Noir Leather Jacket",
    "Premium faux leather",
    "Subtle matte finish",
    "Clean, refined stitching",
    "Smooth, high-quality hardware",
    "Soft inner lining",
    "Wearing size XL"
   ],
   "fit": "Model: 190 cm, 90 kg",
   "images": [
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/01.webp",
     "w": 1400,
     "h": 1867
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/02.webp",
     "w": 1365,
     "h": 2048
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/03.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/04.webp",
     "w": 1400,
     "h": 1817
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/05.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/06.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-matte-black-leather-jacket/07.webp",
     "w": 1365,
     "h": 2048
    }
   ],
   "faux": true
  },
  {
   "handle": "altieros-brownish-burgundy-leather-jacket",
   "shopTitle": "Leather Jacket - Deep Maroon",
   "name": "Leather Jacket",
   "colour": "Deep Maroon",
   "swatch": "#5b2326",
   "family": "leather-jacket",
   "category": "jackets",
   "collection": "fw26",
   "price": 1380.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 49917390160131
    },
    {
     "size": "M",
     "available": true,
     "variantId": 49917390192899
    },
    {
     "size": "L",
     "available": true,
     "variantId": 49917390225667
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 49917390258435
    }
   ],
   "details": [
    "Leather Jacket - Deep Maroon",
    "Premium faux leather",
    "Rich deep maroon tone",
    "Subtle matte finish",
    "Clean, refined stitching",
    "Soft inner lining",
    "Wearing size XL"
   ],
   "fit": "Model: 190 cm, 90 kg",
   "images": [
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/01.webp",
     "w": 1400,
     "h": 1909
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/02.webp",
     "w": 1365,
     "h": 2048
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/03.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/04.webp",
     "w": 1400,
     "h": 1911
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/05.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/06.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-brownish-burgundy-leather-jacket/07.webp",
     "w": 1400,
     "h": 2100
    }
   ],
   "faux": true
  },
  {
   "handle": "altieros-black-wool-blend-jacket",
   "shopTitle": "Wool-Blend Jacket - Noir",
   "name": "Wool-Blend Jacket",
   "colour": "Noir",
   "swatch": "#1d1c1b",
   "family": "wool-jacket",
   "category": "jackets",
   "collection": "fw26",
   "price": 1280.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 49917391077635
    },
    {
     "size": "M",
     "available": true,
     "variantId": 49917391110403
    },
    {
     "size": "L",
     "available": true,
     "variantId": 49917391143171
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 49917391175939
    }
   ],
   "details": [
    "Wool-Blend Jacket - Noir",
    "Premium wool-blend fabric",
    "Deep black, refined finish",
    "Warm heavyweight feel",
    "Clean, refined stitching",
    "Soft inner lining",
    "Wearing size XL"
   ],
   "fit": "Model: 190 cm, 90 kg",
   "images": [
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/01.webp",
     "w": 1400,
     "h": 1812
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/02.webp",
     "w": 1365,
     "h": 2048
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/03.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/04.webp",
     "w": 1400,
     "h": 1883
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/05.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/06.webp",
     "w": 1365,
     "h": 2048
    },
    {
     "src": "assets/img/products/altieros-black-wool-blend-jacket/07.webp",
     "w": 1400,
     "h": 2100
    }
   ],
   "faux": false
  },
  {
   "handle": "altieros-grey-wool-blend-jacket",
   "shopTitle": "Wool-Blend Jacket - Grey",
   "name": "Wool-Blend Jacket",
   "colour": "Grey",
   "swatch": "#b9b8b4",
   "family": "wool-jacket",
   "category": "jackets",
   "collection": "fw26",
   "price": 1280.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 49917394354435
    },
    {
     "size": "M",
     "available": true,
     "variantId": 49917394387203
    },
    {
     "size": "L",
     "available": true,
     "variantId": 49917394419971
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 49917394452739
    }
   ],
   "details": [
    "Wool-Blend Jacket - Grey",
    "Premium wool-blend fabric",
    "Soft, textured heathered finish",
    "Warm heavyweight feel",
    "Clean, refined stitching",
    "Soft inner lining",
    "Wearing size XL"
   ],
   "fit": "Model: 190 cm, 90 kg",
   "images": [
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/01.webp",
     "w": 1400,
     "h": 1821
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/02.webp",
     "w": 1365,
     "h": 2048
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/03.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/04.webp",
     "w": 1400,
     "h": 1837
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/05.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/06.webp",
     "w": 1400,
     "h": 2100
    },
    {
     "src": "assets/img/products/altieros-grey-wool-blend-jacket/07.webp",
     "w": 1365,
     "h": 2048
    }
   ],
   "faux": false
  },
  {
   "handle": "textured-knit-polo-ecru",
   "shopTitle": "ALTIERO's Textured Knit Polo - Ecru",
   "name": "Textured Knit Polo",
   "colour": "Ecru",
   "swatch": "#e9e3d6",
   "family": "knit-polo",
   "category": "knitwear",
   "collection": "summer26",
   "price": 499.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 48169995960579
    },
    {
     "size": "M",
     "available": true,
     "variantId": 48169995993347
    },
    {
     "size": "L",
     "available": true,
     "variantId": 48169996026115
    }
   ],
   "details": [
    "IMPORTANT: Wash with cold water only — Do not iron",
    "· Soft ecru tone",
    "· Muscle Fit",
    "· Premium knit fabric",
    "· Open textured collar for a minimal finish"
   ],
   "fit": null,
   "images": [
    {
     "src": "assets/img/products/textured-knit-polo-ecru/01.webp",
     "w": 1024,
     "h": 1536
    },
    {
     "src": "assets/img/products/textured-knit-polo-ecru/02.webp",
     "w": 1080,
     "h": 1080
    }
   ],
   "faux": false
  },
  {
   "handle": "textured-knit-polo-black",
   "shopTitle": "ALTIERO's Textured Knit Polo - Black",
   "name": "Textured Knit Polo",
   "colour": "Black",
   "swatch": "#151515",
   "family": "knit-polo",
   "category": "knitwear",
   "collection": "summer26",
   "price": 499.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 48169957851395
    },
    {
     "size": "M",
     "available": true,
     "variantId": 48169957884163
    },
    {
     "size": "L",
     "available": true,
     "variantId": 48169957916931
    }
   ],
   "details": [
    "IMPORTANT: Wash with cold water only — Do not iron",
    "· Deep black tone",
    "· Muscle Fit",
    "· Premium knit fabric",
    "· Open textured collar for a minimal finish"
   ],
   "fit": null,
   "images": [
    {
     "src": "assets/img/products/textured-knit-polo-black/01.webp",
     "w": 1086,
     "h": 1448
    },
    {
     "src": "assets/img/products/textured-knit-polo-black/02.webp",
     "w": 1080,
     "h": 1080
    }
   ],
   "faux": false
  },
  {
   "handle": "blue-knitted-tee",
   "shopTitle": "ALTIERO’s Knitted Crewneck - Blue",
   "name": "Knitted Crewneck",
   "colour": "Blue",
   "swatch": "#2c4a7a",
   "family": "knit-crewneck",
   "category": "knitwear",
   "collection": "summer26",
   "price": 499.0,
   "sizes": [
    {
     "size": "M",
     "available": false,
     "variantId": 48169940975875
    },
    {
     "size": "L",
     "available": true,
     "variantId": 48169941008643
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 48169941041411
    }
   ],
   "details": [
    "IMPORTANT: Wash with cold water only — Do not iron",
    "· Rich cobalt blue tone",
    "· Premium knit fabric",
    "· Clean crew neck for a minimal finish"
   ],
   "fit": null,
   "images": [
    {
     "src": "assets/img/products/blue-knitted-tee/01.webp",
     "w": 1086,
     "h": 1448
    },
    {
     "src": "assets/img/products/blue-knitted-tee/02.webp",
     "w": 1400,
     "h": 1867
    },
    {
     "src": "assets/img/products/blue-knitted-tee/03.webp",
     "w": 1080,
     "h": 1080
    }
   ],
   "faux": false
  },
  {
   "handle": "relaxed-tailor-pants-eclipse",
   "shopTitle": "ALTIERO’s Tailored Pants - Eclipse",
   "name": "Tailored Pants",
   "colour": "Eclipse",
   "swatch": "#2a2522",
   "family": "tailored-pants",
   "category": "pants",
   "collection": "tailored",
   "price": 550.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 47868035825923
    },
    {
     "size": "M",
     "available": false,
     "variantId": 47868035858691
    },
    {
     "size": "L",
     "available": false,
     "variantId": 47868035891459
    },
    {
     "size": "XL",
     "available": false,
     "variantId": 47868035924227
    }
   ],
   "details": [
    "Deep matte brownish black tone (Eclipse)",
    "Relaxed classic fit",
    "Premium all-season fabric",
    "Clean minimal pleat near the pockets",
    "Comfortable for all-day wear",
    "Suitable for casual & formal occasions"
   ],
   "fit": "Model is wearing size XL Height: 191 cm · Weight: 90 kg",
   "images": [
    {
     "src": "assets/img/products/relaxed-tailor-pants-eclipse/01.webp",
     "w": 1024,
     "h": 1536
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-eclipse/02.webp",
     "w": 842,
     "h": 1264
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-eclipse/03.webp",
     "w": 1400,
     "h": 1867
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-eclipse/04.webp",
     "w": 1400,
     "h": 1867
    }
   ],
   "faux": false
  },
  {
   "handle": "relaxed-tailor-pants-graphite",
   "shopTitle": "ALTIERO’s Tailored Pants - Graphite",
   "name": "Tailored Pants",
   "colour": "Graphite",
   "swatch": "#4b4d50",
   "family": "tailored-pants",
   "category": "pants",
   "collection": "tailored",
   "price": 550.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 47868042313987
    },
    {
     "size": "M",
     "available": true,
     "variantId": 47868042346755
    },
    {
     "size": "L",
     "available": true,
     "variantId": 47868042379523
    },
    {
     "size": "XL",
     "available": false,
     "variantId": 47868042412291
    }
   ],
   "details": [
    "Rich charcoal gray tone (Graphite)",
    "Relaxed classic fit",
    "Premium all-season fabric",
    "Clean minimal pleat near the pockets",
    "Comfortable for all-day wear",
    "Suitable for casual & formal occasions"
   ],
   "fit": "Model is wearing size XL Height: 191 cm · Weight: 90 kg",
   "images": [
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/01.webp",
     "w": 1024,
     "h": 1536
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/02.webp",
     "w": 842,
     "h": 1264
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/03.webp",
     "w": 1400,
     "h": 1867
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/04.webp",
     "w": 1400,
     "h": 2489
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/05.webp",
     "w": 1400,
     "h": 2489
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-graphite/06.webp",
     "w": 1400,
     "h": 1867
    }
   ],
   "faux": false
  },
  {
   "handle": "relaxed-tailor-pants-navy",
   "shopTitle": "ALTIERO’s Tailored Pants - Navy",
   "name": "Tailored Pants",
   "colour": "Navy",
   "swatch": "#23304a",
   "family": "tailored-pants",
   "category": "pants",
   "collection": "tailored",
   "price": 550.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 47868056895747
    },
    {
     "size": "M",
     "available": true,
     "variantId": 47868056928515
    },
    {
     "size": "L",
     "available": true,
     "variantId": 47868056961283
    },
    {
     "size": "XL",
     "available": true,
     "variantId": 47868056994051
    }
   ],
   "details": [
    "Deep midnight navy tone (Navy)",
    "Relaxed classic fit",
    "Premium all-season fabric",
    "Clean minimal pleat near the pockets",
    "Comfortable for all-day wear",
    "Suitable for casual & formal occasions"
   ],
   "fit": "Model is wearing size XL Height: 191 cm · Weight: 90 kg",
   "images": [
    {
     "src": "assets/img/products/relaxed-tailor-pants-navy/01.webp",
     "w": 1024,
     "h": 1536
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-navy/02.webp",
     "w": 842,
     "h": 1264
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-navy/03.webp",
     "w": 1400,
     "h": 1867
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-navy/04.webp",
     "w": 1400,
     "h": 1866
    },
    {
     "src": "assets/img/products/relaxed-tailor-pants-navy/05.webp",
     "w": 1400,
     "h": 1867
    }
   ],
   "faux": false
  },
  {
   "handle": "altieros-ecru-wool-blend-jacket-copy",
   "shopTitle": "ALTIERO's Wool-Blend Jacket - TAUPE",
   "name": "Cropped Wool-Blend Jacket",
   "colour": "Taupe",
   "swatch": "#b5a796",
   "family": "cropped-wool-jacket",
   "category": "jackets",
   "collection": "fw26",
   "price": 1480.0,
   "sizes": [
    {
     "size": "S",
     "available": true,
     "variantId": 47596310233347
    },
    {
     "size": "M",
     "available": false,
     "variantId": 47596310266115
    },
    {
     "size": "L",
     "available": false,
     "variantId": 47596310298883
    },
    {
     "size": "XL",
     "available": false,
     "variantId": 47596310331651
    }
   ],
   "details": [
    "Boxy fit",
    "Wool-blend fabric",
    "Inner pocket"
   ],
   "fit": null,
   "images": [
    {
     "src": "assets/img/products/altieros-ecru-wool-blend-jacket-copy/01.webp",
     "w": 1024,
     "h": 1536
    },
    {
     "src": "assets/img/products/altieros-ecru-wool-blend-jacket-copy/02.webp",
     "w": 1080,
     "h": 1080
    }
   ],
   "faux": false
  }
 ],
 "videos": [
  {
   "src": "assets/video/clip-01.mp4",
   "poster": "assets/video/clip-01.jpg",
   "source": "017f097f4e8d45bfbfce3e40b7dea31f.HD-1080p-4.8Mbps-83599983.mp4"
  },
  {
   "src": "assets/video/clip-02.mp4",
   "poster": "assets/video/clip-02.jpg",
   "source": "07265749e39f4442a1a6fee77455d126.HD-1080p-4.8Mbps-91010061.mp4"
  },
  {
   "src": "assets/video/clip-03.mp4",
   "poster": "assets/video/clip-03.jpg",
   "source": "1421f2f214ca4d68b221bc1f65d4c5d2.HD-1080p-7.2Mbps-89098656.mp4"
  },
  {
   "src": "assets/video/clip-04.mp4",
   "poster": "assets/video/clip-04.jpg",
   "source": "1bfe98d36e9042bc9b826bbfeda487d1.HD-1080p-3.3Mbps-88452126.mp4"
  },
  {
   "src": "assets/video/clip-05.mp4",
   "poster": "assets/video/clip-05.jpg",
   "source": "31f40032540b49e79bd02611c6c79b6a.HD-1080p-4.8Mbps-89100031.mp4"
  },
  {
   "src": "assets/video/clip-06.mp4",
   "poster": "assets/video/clip-06.jpg",
   "source": "34456fe7cbf94265aa05a63c1031464e.HD-1080p-3.3Mbps-83599652.mp4"
  },
  {
   "src": "assets/video/clip-07.mp4",
   "poster": "assets/video/clip-07.jpg",
   "source": "37bef22b761446d2b83f1733eeab57a1.HD-1080p-4.8Mbps-67149180.mp4"
  },
  {
   "src": "assets/video/clip-08.mp4",
   "poster": "assets/video/clip-08.jpg",
   "source": "5417be7c7b6148358c3a68e12670f3ce.HD-1080p-7.2Mbps-83599841.mp4"
  },
  {
   "src": "assets/video/clip-09.mp4",
   "poster": "assets/video/clip-09.jpg",
   "source": "5bc7569eeab14d4dbf3dd7e2a569701e.HD-1080p-4.8Mbps-87520095.mp4"
  },
  {
   "src": "assets/video/clip-10.mp4",
   "poster": "assets/video/clip-10.jpg",
   "source": "82b7bc3b678d4d599888e716fa83ff18.HD-1080p-7.2Mbps-91009920.mp4"
  },
  {
   "src": "assets/video/clip-11.mp4",
   "poster": "assets/video/clip-11.jpg",
   "source": "91a3f918435448d59cf59e9ffa34aa35.HD-1080p-3.3Mbps-83599824.mp4"
  },
  {
   "src": "assets/video/clip-12.mp4",
   "poster": "assets/video/clip-12.jpg",
   "source": "cc1685a5b9254caf8eb3c4d3ee7ff289.HD-1080p-4.8Mbps-81165202.mp4"
  }
 ]
};
